import React, { useState } from 'react';
import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Typography,
  Paper,
  useMediaQuery,
  useTheme,
  Fab,
  Button,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import DashboardHeader from './DashboardHeader.tsx';
import FormTabs from './FormTabs.tsx';
import { useRecoilState } from 'recoil';
import { campaignLeadManagementAtom } from '../../../Services/_states/index.js';
import { Card } from 'react-bootstrap';
import LeadList from './LeadList.tsx';
import { useNavigate } from 'react-router';

// Enhanced Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#4962e5',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 12,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          minHeight: 64,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
  },
});

function LeadManagement() {
  const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
    campaignLeadManagementAtom
  );
  const themeHook = useTheme();
  const isMobile = useMediaQuery(themeHook.breakpoints.down('md'));
  const navigate = useNavigate();

  // const handleAddLead = () => {
  //   console.log(true);
  // };

  const toCreateDashboard = () => {
    navigate('/r/management/manageCampaign/');
  };

  return (
    // <ThemeProvider theme={theme}>
    //   <CssBaseline />
    <Box sx={{ flexGrow: 1, minHeight: '85vh' }}>
      {/* <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}> */}
      <DashboardHeader />
      {/* Form Tabs Section */}
      {campaignLeadManagementData?.selectedCampaign ? (
        <>
          {campaignLeadManagementData?.selectedCampaign?.proposal_id &&
          campaignLeadManagementData?.[campaignLeadManagementData?.selectedCampaign?.proposal_id]
            ?.length > 1 ? (
            <FormTabs />
          ) : null}
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: 400,
            gap: 2,
          }}
        >
          <Typography variant="body1" color="text.secondary">
            Please Select a Dashboard or Create New Dashboard
          </Typography>

          <Button
            onClick={toCreateDashboard}
            variant="outlined"
            size="small"
            sx={{ width: { xs: '100%', sm: 'auto' } }}
            startIcon={<AddIcon />}
          >
            Create Dashboard
          </Button>
        </Box>
      )}

      <Box>
        {/* Content Tabs */}
        {campaignLeadManagementData?.selectedForm && <LeadList />}

        {campaignLeadManagementData?.selectedCampaign &&
          campaignLeadManagementData?.[campaignLeadManagementData?.selectedCampaign?.proposal_id]
            ?.length <= 0 && (
            <Box
              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}
            >
              <Typography variant="body1" color="text.secondary">
                No forms available. Create your first form to get started.
              </Typography>
            </Box>
          )}
      </Box>
      {/* Recent Activity Section */}
      {/* {selectedForm && (
          <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, boxShadow: 3, mt: 3 }}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Recent Activity
              </Typography>
              <Button size="small" variant="outlined">
                View All
              </Button>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              {selectedForm.leads.slice(0, 3).map((lead) => (
                <Card key={lead.id} sx={{ flex: '1 1 300px', minWidth: 0 }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.main' }}>{lead.name.charAt(0)}</Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {lead.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {lead.email}
                        </Typography>
                      </Box>
                      <Chip
                        label={lead.status}
                        size="small"
                        color={
                          lead.status === 'new'
                            ? 'default'
                            : lead.status === 'contacted'
                              ? 'primary'
                              : lead.status === 'qualified'
                                ? 'warning'
                                : 'success'
                        }
                      />
                    </Box>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mt: 1, display: 'block' }}
                    >
                      Added {lead.createdAt} • Source: {lead.source || 'Unknown'}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Paper>
        )} */}
      {/* </Container> */}

      {/* Floating Action Button for Mobile */}
      {/* {isMobile && (
        <Fab
          color="primary"
          aria-label="add"
          onClick={handleAddLead}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
          }}
        >
          <AddIcon />
        </Fab>
      )} */}
      {/* Lead Management Dialog */}
    </Box>
    // </ThemeProvider>
  );
}

export default LeadManagement;
